import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrl: './image-upload.component.scss'
})
export class ImageUploadComponent {

  @Input() image: string;
  @Input() uploadText = 'Upload Image';
  @Input() maxWidth = 200;
  @Input() maxHeight = 200;

  @Output() fileUpload: EventEmitter<File> = new EventEmitter<File>();
  @Output() fileDelete: EventEmitter<void> = new EventEmitter<void>();

  fileData: File = null;
  previewUrl: any = null;

  @ViewChild('file') fileRef!: ElementRef;

  onFileSelect(fileInput: any) {
    this.fileData = fileInput.target.files[0] as File;
    if (this.fileData) {
      this.preview();
      this.fileUpload.emit(this.fileData);
    }
  }

  preview() {
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (event) => {
      this.previewUrl = reader.result;
    };
  }

  removePicture(event: Event) {
    event.stopPropagation();
    this.clearImage();
    this.fileDelete.emit();
  }

  private clearImage() {
    this.image = this.previewUrl = null;
    this.fileData = null;
    this.fileRef.nativeElement.value = '';
  }

  noImage(): boolean {
    return !this.image && !this.previewUrl;
  }
}
